import { simpleAjaxDispatch } from './http';

export function initApp() {
  return simpleAjaxDispatch('/scan?internal_only=true', 'scanTypes');
}
